import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=warm%20sunset%20coastal%20community%20gathering%20abstract%20artistic%20style%20soft%20gradient%20sky%20silhouettes%20of%20people%20connecting%20emotional%20warm%20atmosphere%20dreamy%20soft%20focus%20orange%20peach%20cream%20tones%20peaceful%20vibe&width=1800&height=900&seq=hero-bg-2026&orientation=landscape"
        alt="海角社区 - 情感交流平台"
        title="海角社区情感交流"
        className="absolute inset-0 w-full h-full object-cover object-top"
        fetchPriority="high"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/45"></div>

      <div className="relative z-10 w-full max-w-3xl mx-auto px-4 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-5 leading-tight">
          每一个故事，都值得被倾听
        </h1>
        <p className="text-base md:text-lg text-white/85 mb-8 max-w-xl mx-auto leading-relaxed">
          海角社区汇聚百万真实用户，分享情感故事、生活感悟与人生经历。在这里，找到理解与共鸣。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/qinggan-qingsu"
            className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-full text-sm transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/25"
          >
            开始探索
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-white/15 hover:bg-white/25 backdrop-blur-sm text-white font-medium rounded-full text-sm transition-all duration-300 whitespace-nowrap cursor-pointer border border-white/25"
          >
            了解更多
          </Link>
        </div>

        <div className="flex items-center justify-center gap-8 mt-10 text-white/70 text-xs">
          <div className="flex items-center gap-1.5">
            <i className="ri-shield-check-line text-sm"></i>
            <span>真实用户</span>
          </div>
          <div className="flex items-center gap-1.5">
            <i className="ri-lock-line text-sm"></i>
            <span>隐私保护</span>
          </div>
          <div className="flex items-center gap-1.5">
            <i className="ri-emotion-happy-line text-sm"></i>
            <span>温暖社区</span>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-s-line text-white/50 text-2xl"></i>
      </div>
    </section>
  );
}